import React from 'react'
import { Card, CardBody } from 'reactstrap'
import { CC_ESTEIRA_STEPS, formatBudgetMoney } from './budgetDashboardHelpers'

const SUMMARY_STEPS = [
  ...CC_ESTEIRA_STEPS,
  { key: 'disponivel', label: 'Disponível', color: '#6f42c1' },
]

const BudgetEsteiraSummaryCards = ({ totals }) => {
  if (!totals) return null

  return (
    <div
      className="d-flex flex-nowrap mb-3"
      style={{ gap: 8, overflowX: 'auto', paddingBottom: 2 }}
    >
      {SUMMARY_STEPS.map(step => {
        const valor = Number(totals[step.key] || 0)
        return (
          <Card
            key={step.key}
            className="border shadow-sm mb-0"
            style={{ flex: '1 1 0', minWidth: 130 }}
          >
            <CardBody className="py-2 px-3">
              <div
                className="text-muted text-uppercase mb-1"
                style={{ fontSize: '0.65rem', letterSpacing: '0.03em', whiteSpace: 'nowrap' }}
              >
                {step.label}
              </div>
              <div
                className="font-weight-bold"
                style={{ fontSize: '0.95rem', color: step.color || '#273351', whiteSpace: 'nowrap' }}
              >
                {formatBudgetMoney(valor)}
              </div>
            </CardBody>
          </Card>
        )
      })}
    </div>
  )
}

export default BudgetEsteiraSummaryCards
